module.exports = __webpack_public_path__ + "img/Reportred.87de0a4a.svg";